var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBatteryCharging(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "30px",
    height: "30px",
    viewBox: "0 0 91.892 91.892",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M64.658,3.624H54.131V1.488c0-0.823-0.66-1.488-1.485-1.488H39.247c-0.828,0-1.494,0.666-1.494,1.488v2.136h-10.52 c-2.498,0-4.538,2.036-4.538,4.538v79.189c0,2.501,2.04,4.541,4.538,4.541h37.424c2.499,0,4.538-2.04,4.538-4.541V8.162 C69.196,5.66,67.157,3.624,64.658,3.624z M61.75,84.445H30.142V11.07H61.75V84.445z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.587,52.235c0.057-0.027,0.103-0.062,0.15-0.092c-1.377,3.021-2.735,6.054-4.043,9.106 c-2.313,5.523-4.56,11.081-6.427,16.816c3.504-4.921,6.634-10.034,9.687-15.181c3.017-5.175,5.926-10.383,8.677-15.688 l3.765-7.264l-7.231,3.949c-2.361,1.28-4.745,2.538-7.058,3.91c-0.459,0.267-0.904,0.548-1.371,0.814 c1.049-2.861,2.136-5.712,3.109-8.604c1.702-4.986,3.266-10.028,4.604-15.167c-2.697,4.574-5.183,9.228-7.527,13.947 c-2.368,4.714-4.625,9.467-6.784,14.265l-2.642,5.887l5.968-2.93C41.882,54.823,44.23,53.516,46.587,52.235z"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBatteryCharging);
export default __webpack_public_path__ + "static/media/battery-charging.6197fea69444a637e715e88c76ccdcf6.svg";
export { ForwardRef as ReactComponent };